import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/sended.svg'
import _imports_1 from '@/assets/img/received.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4e683bf5")

_pushScopeId("data-v-4e683bf5")
const _hoisted_1 = { class: "chatRow justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "pallinoNotifiche"
}
const _hoisted_4 = { class: "data" }
const _hoisted_5 = { class: "fs_16 greyBlue d-block ln_12" }
const _hoisted_6 = {
  key: 1,
  class: "fs_10 grey d-block ln_12"
}
const _hoisted_7 = {
  key: 0,
  class: "requestType"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", {
        class: "userImage position-relative",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openProfile && _ctx.openProfile(...args)), ["stop","prevent"]))
      }, [
        (_ctx.$store.state.newChatMessages && _ctx.$store.state.newChatMessages.indexOf(_ctx.item.identifier) != -1)
          ? (_openBlock(), _createBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ], 512), [
        [_directive_userimage, _ctx.$store.state.getUserImage(_ctx.item.userIdentifier)]
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.item.name), 1),
        (_ctx.item.lastMessage)
          ? (_openBlock(), _createBlock("span", {
              key: 0,
              class: "fs_12 greyBlue d-block ln_12 message",
              innerHTML: _ctx.item.lastMessage.text
            }, null, 8, ["innerHTML"]))
          : _createCommentVNode("", true),
        (_ctx.item.lastMessage)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$filters.chatDate(_ctx.item.lastMessage.date)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.item.type == 'FriendRequest')
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          ((_ctx.item as any).fromUser == _ctx.$store.state.user.identifier)
            ? (_openBlock(), _createBlock("img", _hoisted_8))
            : (_openBlock(), _createBlock("img", _hoisted_9))
        ]))
      : _createCommentVNode("", true)
  ]))
})